import numbro from 'numbro';

export default (num, digits) => {
  return numbro(num).format({ mantissa: digits, roundingFunction: Math.floor });
};
